import AiToolPanel from "@/components/ai/AiToolPanel";

const examples = [
  { label: "Email", value: "Match a valid email address" },
  { label: "US phone", value: "Match a US phone number with optional +1 country code, dashes or spaces" },
  { label: "Hex color", value: "Match a 3 or 6 digit hex color like #fff or #ffffff" },
  { label: "Slug", value: "Match a URL slug: lowercase letters, numbers and hyphens, 3-60 chars" },
];

const RegexGenerator = () => (
  <AiToolPanel
    task="regex-generate"
    inputLabel="Describe the pattern in plain English"
    placeholder="e.g. Match an IPv4 address with optional port number"
    buttonLabel="Generate regex"
    rows={4}
    examples={examples}
  />
);

export default RegexGenerator;